import _ from 'lodash';
import approximateFraction from "./fractions.js";
const axios = require('axios')
const RobustWebSocket = require('robust-websocket')
const pako = require('pako')
const querystring = require('querystring')

class WebSocketClient {
    constructor(url) {
        this.url = url;
        this.socket = null;
    }

    async connect() {
        this.socket = new RobustWebSocket(this.url);
        this.socket.addEventListener('open', () => {
            console.log('WebSocket connection is open.');
        });

        this.socket.addEventListener('error', (event) => {
            console.error('WebSocket error:', event);
        });

        return new Promise((resolve) => {
            this.socket.addEventListener('open', () => {
                resolve();
            });
        });
    }
    
    generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0,
              v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
    }

    async send(action, params) {

		let message = {}
		message.event = action;
		params.id = this.generateUUID();
		message.data = params;
		console.log('params_' + action, new URLSearchParams(params).toString())
        return new Promise((resolve, reject) => {
            //reject("error");
            if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
                reject('WebSocket is not connected.');
            }
            this.socket.send(JSON.stringify(message));
			
			const messageHandler = (event) => {
                const response = JSON.parse(event.data);
				if(_.get(message, 'data.id') == _.get(response, 'data.id')) {
				    if(_.get(message, 'data.status')) {
					    this.socket.removeEventListener('message', messageHandler);
                    }
					let result = {}
					const gzipedByteArray = Uint8Array.from(atob(_.get(response, 'data.response')), c => c.charCodeAt(0));
					const decompressedByteArray = pako.ungzip(gzipedByteArray);
					const decompressedString = new TextDecoder().decode(decompressedByteArray);
					result.response = JSON.parse(decompressedString);
					resolve(result);
				}
            };
			
            this.socket.addEventListener('message', messageHandler);
            this.socket.addEventListener('error', (error) => {
                reject(error);
            });
        });
    }

    async close() {
        if (this.socket) {
            this.socket.close();
        }
    }
}

export default class Sportsbook {

    constructor() {
        this.memory = {};
        if(!window.ws && process.env.WEBSOCKET_URL) {
            window.ws = new WebSocketClient(process.env.WEBSOCKET_URL);
            ws.connect();
        }
    }

    formatOdds(decimal, mode) {
        decimal = parseFloat(decimal || 0);
        if (mode === 'american') {
            let moneyline = null
            decimal < 2.0 ? moneyline = ( (-100)/(decimal - 1) ).toPrecision(5) : moneyline = ( (decimal - 1) * 100 ).toPrecision(5);
            return moneyline
        } else if (mode === 'fractional') {
            return approximateFraction( decimal - 1);
        } else {
            var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (2) + '})?');
            return decimal.toString().match(re)[0];
        }
    }

    fixFloatError(n) {
        return parseFloat(n.toPrecision(12));
    }

    simpleHash(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash &= hash; // Convert to 32bit integer
        }
        return new Uint32Array([hash])[0].toString(36);
    }

    async initListener() {
        emitter.on('events', (e) => {
            //loop maps, check if events have change and refetch
            for (let hash in this.memory) {
                if (_.size(_.intersection(e, _.get(this.memory, hash + '.events')))) {
                    this.getEvents(_.get(this.memory, hash + '.params'), _.get(this.memory, hash + '.callback'));
                }
            }
        })
    }

    async loadEvents(params = {}, callback) {
        let response = await this._findEventsWithMainMarkets(params, this._findEventsWithMainMarkets);
        callback(response);

        let tmp = {
            params: params,
            callback: callback,
            events: _.chain(response.events).map('id').value(),
        }
        let hash = this.simpleHash(new URLSearchParams(params).toString());
        this.memory[hash] = tmp;
    }
    
    async getEvents(params = {}, callback) {
        let response = await this._findEvents(params, this._findEvents);
        callback(response);

        let tmp = {
            params: params,
            callback: callback,
            events: _.chain(response.competitions).flatMap('events').map('id').value(),
        }
        let hash = this.simpleHash(new URLSearchParams(params).toString());
        this.memory[hash] = tmp;
    }

    async _findEventsWithMainMarkets(params = {}) {
        params.bookmaker = process.env.BOOKMAKER
        console.log('_findEventsWithMainMarkets', new URLSearchParams(params).toString());

        return new Promise((resolve, reject) => {
            ws.send('events', params).then((response) => {
                resolve(response.response)
            }).catch(error => {
                axios.get(process.env.SPORTSBOOK_API + '/echo/v1/events', {
                    timeout: 10000,
                    params: params
                })
                .then(function (response) {
                    resolve(response.data)
                })
                .catch(reason => {
                    reject(reason);
                });
              })

        });
    }

    async getLiveEvents(params = {}, callback) {
        let response = await this._getLiveEvents(params);
        callback(response);

        let tmp = {
            params: params,
            callback: callback
        }
        let hash = this.simpleHash(new URLSearchParams(params).toString());
        this.memory[hash] = tmp;
    }

    async _getLiveEvents(params = {}) {
        params.bookmaker = process.env.BOOKMAKER
        params = _.omitBy(params, _.isNull)
        return new Promise((resolve, reject) => {
            ws.send('events-live', params).then((response) => {
                resolve(response.response)
            }).catch(error => {
                axios.get(process.env.SPORTSBOOK_API + '/echo/v1/events-live', {
                    timeout: 10000,
                    params: params
                })
                .then(function (response) {
                    resolve(response.data)
                })
                .catch(reason => {
                    reject(reason);
                });
              })

        });
    }

    async getMarkets(params = {}, callback) {
        let response = await this._getMarkets(params, this._findEventsWithMainMarkets);
        callback(response);

        let tmp = {
            params: params,
            callback: callback
        }
        let hash = this.simpleHash(new URLSearchParams(params).toString());
        this.memory[hash] = tmp;
    }

    async _getMarkets(params = {}) {
        params.bookmaker = process.env.BOOKMAKER
        params = _.omitBy(params, _.isNull)
        return new Promise((resolve, reject) => {
            /*ws.send('markets', params).then((response) => {
                resolve(response.response)
            }).catch(error => {*/
                axios.get(process.env.SPORTSBOOK_API + '/echo/v1/markets', {
                    timeout: 10000,
                    params: params
                })
                .then(function (response) {
                    resolve(response.data)
                })
                .catch(reason => {
                    reject(reason);
                });
              })

        //});
    }

    async _findEvents(params = {}) {
        params.bookmaker = process.env.BOOKMAKER
        params = _.omitBy(params, _.isNull)
        return new Promise((resolve, reject) => {
            if(process.env.WEBSOCKET_URL) {
                /*ws.send('events-simple', params).then((response) => {
                    console.log('events-simple', params, response)
                    resolve(response.response)
                }).catch(error => {*/
                    axios.get(process.env.SPORTSBOOK_API + '/echo/v1/events-simple', {
                        timeout: 10000,
                        params: params
                    })
                    .then(function (response) {
                        resolve(response.data)
                    })
                    .catch(reason => {
                        reject(reason);
                    });
                //})
            } else {
                window.socket.send('find', 'events', params, (error, response) => {
                    if (!error) {
                        resolve(response)
                    } else {
                        reject(error);
                    }
                })
            }
        });
    }

    async getSelections(params = {}, callback) {
        const response = await this._getSelections(params);

        if (typeof callback === 'function') {
            callback(response);
        }

        // Use JSON.stringify for the hash instead of URLSearchParams
        // because params contains nested arrays/objects
        const hash = this.simpleHash(JSON.stringify(params));
        this.memory[hash] = { params, callback };

        return response;
    }

    async _getSelections(params = {}) {
        const payload = _.omitBy({
            ...params,
            bookmaker: process.env.BOOKMAKER
        }, _.isNull);

        try {
            const response = await axios.post(
                `${process.env.SPORTSBOOK_API}/echo/v1/selections`,
                payload,
                {
                    timeout: 10000,
                    params: _.pick(payload, ['bookmaker', 'lang', 'country'])
                }
            );
            return response.data;
        } catch (error) {
            console.error("API Error in _getSelections:", error);
            throw error;
        }
    }

    async _findEventsOld(params = {}) {
        params.bookmaker = process.env.BOOKMAKER
        return new Promise((resolve, reject) => {
            window.socket.send('find', 'events', params, (error, response) => {
                if (!error) {
                    resolve(response)
                } else {
                    reject(error);
                }
            })
        });
    }
}